import news from './mod/news'
import honor from './mod/honor'
import about from './mod/about'
import device from './mod/device'
import service from './mod/service'
import guide from './mod/guide'
import personal from './mod/personal'

export default {
  news,
  honor,
  about,
  device,
  service,
  guide,
  personal,
}
